import React from 'react'

const PlacementResult = () => {
  return (
    <h2>THANKS</h2>
  )
}

export default PlacementResult